<template>
	<div class="page">
		<el-form>
			<div class="line">
				<el-form-item label="订单导出：" :label-width="formLabelWidth">
					<el-date-picker @change="changeOrderTime" v-model="search.order.dateRange" type="daterange"
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false">
					</el-date-picker>
					<el-button type="primary" style="margin-left:50px;" @click="down('order')">导出</el-button>
				</el-form-item>
				<el-form-item label="医疗服务导出：" :label-width="formLabelWidth">
					<el-date-picker @change="changeYlfwTime" v-model="search.ylfw.dateRange" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false">
					</el-date-picker>
					<el-button type="primary" style="margin-left:50px;" @click="down('ylfw')">导出</el-button>
				</el-form-item>
				<el-form-item label="成本价导出：" :label-width="formLabelWidth">
					<el-date-picker @change="changeChengbenjiaTime" v-model="search.chengbenjia.dateRange" type="daterange"
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false">
					</el-date-picker>
					<span style="padding-left:20px;">供应商：</span>
					<el-select v-model="search.chengbenjia.supplier" placeholder="请选择" clearable filterable style="width:160px;">
						<el-option v-for="item in supplierList" :key="item._id" :label="item.basic_info.name" :value="item._id">
						</el-option>
					</el-select>
					<span style="padding-left:20px;">关键字：</span>
					<el-input v-model="search.chengbenjia.keyword" style="width:200px;" placeholder="关键字"></el-input>
					<el-button type="primary" style="margin-left:50px;" @click="down('chengbenjia')">导出</el-button>
				</el-form-item>
				<el-form-item label="入库导出：" :label-width="formLabelWidth">
					<el-date-picker @change="changeRukuTime" v-model="search.ruku.dateRange" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false">
					</el-date-picker>
					<span style="padding-left:20px;">类型：</span>
					<el-select v-model="search.ruku.type" placeholder="请选择" clearable style="width:160px;">
						<el-option v-for="item in inTypeList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					<span style="padding-left:20px;">门店：</span>
					<el-select v-model="search.ruku.shopId" placeholder="请选择" clearable style="width:120px;">
						<el-option v-for="item in shopList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-button type="primary" style="margin-left:50px;" @click="down('ruku')">导出</el-button>
				</el-form-item>
				<el-form-item label="出库导出：" :label-width="formLabelWidth">
					<el-date-picker @change="changeChukuTime" v-model="search.chuku.dateRange" type="daterange"
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false">
					</el-date-picker>
					<span style="padding-left:20px;">类型：</span>
					<el-select v-model="search.chuku.type" placeholder="请选择" clearable style="width:160px;">
						<el-option v-for="item in outTypeList" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					<span style="padding-left:20px;">门店：</span>
					<el-select v-model="search.chuku.shopId" placeholder="请选择" clearable style="width:120px;">
						<el-option v-for="item in shopList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-button type="primary" style="margin-left:50px;" @click="down('chuku')">导出</el-button>
				</el-form-item>
				<el-form-item label="采购分拨单导出：" :label-width="formLabelWidth">
					<el-date-picker @change="changeFenboTime" v-model="search.fenbo.dateRange" type="daterange"
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false">
					</el-date-picker>
					<span style="padding-left:20px;">供应商：</span>
					<el-select v-model="search.fenbo.supplier" placeholder="请选择" clearable filterable style="width:160px;">
						<el-option v-for="item in supplierList" :key="item._id" :label="item.basic_info.name" :value="item._id">
						</el-option>
					</el-select>
					<span style="padding-left:20px;">门店：</span>
					<el-select v-model="search.fenbo.shopId" placeholder="请选择" clearable style="width:120px;">
						<el-option v-for="item in shopList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<span style="padding-left:20px;">关键字：</span>
					<el-input v-model="search.fenbo.keyword" style="width:200px;" placeholder="关键字"></el-input>
					<el-button type="primary" style="margin-left:50px;" @click="down('fenbo')">导出</el-button>
				</el-form-item>
				<el-form-item label="商品销售数据导出：" :label-width="formLabelWidth">
					<el-date-picker @change="changesaleTime" v-model="search.goods.dateRange" type="daterange" range-separator="至"
						start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false">
					</el-date-picker>
					<el-button type="primary" style="margin-left:50px;" @click="down('goods')">导出</el-button>
				</el-form-item>
				<el-form-item label="药品销售数据导出：" :label-width="formLabelWidth">
					<el-date-picker @change="changemedicalTime" v-model="search.medical.dateRange" type="daterange"
						range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" :clearable="false">
					</el-date-picker>
					<el-button type="primary" style="margin-left:50px;" @click="down('medical')">导出</el-button>
				</el-form-item>
				<el-form-item label="库存汇总数据导出" :label-width="formLabelWidth">
					<span style="padding-left:20px;">类型：</span>
					<el-select v-model="search.kucun.type" placeholder="请选择" clearable style="width:160px;">
						<el-option v-for="item in goodsType" :key="item.id" :label="item.name" :value="item.id">
						</el-option>
					</el-select>
					<span style="padding-left:20px;">门店：</span>
					<el-select v-model="search.kucun.shopId" placeholder="请选择" clearable style="width:120px;">
						<el-option v-for="item in shopList" :key="item.value" :label="item.label" :value="item.value">
						</el-option>
					</el-select>
					<el-button type="primary" style="margin-left:50px;" @click="down('kucun')">导出</el-button>
				</el-form-item>
			</div>
		</el-form>
	</div>
</template>
<script>
import axios from 'axios';
export default {
	data() {
		return {
			formLabelWidth: '150px',
			shopList: [],
			inTypeList: [{
				id: '0',
				name: '采购验货入库'
			}, {
				id: '1',
				name: '门店盘盈入库'
			}, {
				id: '2',
				name: '门店调拨入库'
			}, {
				id: '3',
				name: '门店销售退货入库'
			}, {
				id: '4',
				name: '初始化库存'
			}],
			goodsType: [{
				id: '0',
				name: '商品'
			}, {
				id: '1',
				name: '药品'
			}, {
				id: '7',
				name: '耗材'
			}],
			outTypeList: [{
				id: '0',
				name: '门店盘亏出库'
			}, {
				id: '1',
				name: '门店销售出库'
			}, {
				id: '2',
				name: '门店调拨出库'
			}, {
				id: '3',
				name: '门店自用出库'
			}, {
				id: '4',
				name: '门店报废'
			}],
			supplierList: [],
			search: {
				order: {
					dateRange: '',
					start_time: '',
					end_time: '',
				},
				ylfw: {
					dateRange: '',
					start_time: '',
					end_time: '',
				},
				ruku: {
					dateRange: '',
					start_time: '',
					end_time: '',
					type: '',
					shopId: ''
				},

				chuku: {
					dateRange: '',
					start_time: '',
					end_time: '',
					type: '',
					shopId: ''
				},

				kucun: {
					dateRange: '',
					type: '',
					shopId: ''
				},
				chengbenjia: {
					dateRange: '',
					start_time: '',
					end_time: '',
					supplier: '',
					keyword: '',
				},
				fenbo: {
					dateRange: '',
					start_time: '',
					end_time: '',
					supplier: '',
					shopId: '',
					keyword: '',
				},
				goods: {
					dateRange: '',
					start_time: '',
					end_time: '',
				},
				medical: {
					dateRange: '',
					start_time: '',
					end_time: '',
				},
			},
			fileName: '',
		}
	},
	mounted() {
		this.shopList = this.$store.getters['shopList'];
		this.$http.post(process.env.VUE_APP_Url_8000 + '/api/Supplier/list', {
			pageSize: 1000,
			pageIndex: 1,
			keywords: ''
		}).then(res => {
			this.supplierList = res.data.data
		})
	},
	methods: {
		changeOrderTime() {
			this.search.order.start_time = ('' + this.search.order.dateRange[0].getTime()).substr(0, 10);
			this.search.order.end_time = ('' + this.search.order.dateRange[1].getTime()).substr(0, 10);
			this.fileName = '财务导出' +
				this.$public.FTime(this.search.order.start_time, 'YYYY/MM/DD') +
				'至' +
				this.$public.FTime(this.search.order.end_time, 'YYYY/MM/DD') +
				'.xlsx';
			console.log(this.fileName)
		},
		changeYlfwTime() {
			this.search.ylfw.start_time = ('' + this.search.ylfw.dateRange[0].getTime()).substr(0, 10);
			this.search.ylfw.end_time = ('' + this.search.ylfw.dateRange[1].getTime()).substr(0, 10);
			this.fileName = '医疗服务导出' +
				this.$public.FTime(this.search.ylfw.start_time, 'YYYY/MM/DD') +
				'至' +
				this.$public.FTime(this.search.ylfw.end_time, 'YYYY/MM/DD') +
				'.xlsx';
			console.log(this.fileName)
		},
		changeRukuTime() {
			console.log(this.$public.getMatchingItem(this.inTypeList, 'id', this.search.ruku.type).name || '')
			this.search.ruku.start_time = ('' + this.search.ruku.dateRange[0].getTime()).substr(0, 10);
			this.search.ruku.end_time = ('' + this.search.ruku.dateRange[1].getTime()).substr(0, 10);
			this.fileName = '入库导出' +
				this.$public.FTime(this.search.ruku.start_time, 'YYYY/MM/DD') +
				'至' +
				this.$public.FTime(this.search.ruku.end_time, 'YYYY/MM/DD') +
				(this.$public.getMatchingItem(this.inTypeList, 'id', this.search.ruku.type).name || '') +
				'.xlsx';
			console.log(this.fileName)
		},
		changeChukuTime() {
			this.search.chuku.start_time = ('' + this.search.chuku.dateRange[0].getTime()).substr(0, 10);
			this.search.chuku.end_time = ('' + this.search.chuku.dateRange[1].getTime()).substr(0, 10);
			this.fileName = '出库导出' +
				this.$public.FTime(this.search.chuku.start_time, 'YYYY/MM/DD') +
				'至' +
				this.$public.FTime(this.search.chuku.end_time, 'YYYY/MM/DD') +
				(this.$public.getMatchingItem(this.outTypeList, 'id', this.search.chuku.type).name || '') +
				'.xlsx';
			console.log(this.fileName)
		},
		changeChengbenjiaTime() {
			this.search.chengbenjia.start_time = ('' + this.search.chengbenjia.dateRange[0].getTime()).substr(0, 10);
			this.search.chengbenjia.end_time = ('' + this.search.chengbenjia.dateRange[1].getTime()).substr(0, 10);
			this.fileName = '客服导出' +
				this.$public.FTime(this.search.chengbenjia.start_time, 'YYYY/MM/DD') +
				'至' +
				this.$public.FTime(this.search.chengbenjia.end_time, 'YYYY/MM/DD') +
				'.xlsx';
			console.log(this.fileName)
		},
		changeFenboTime() {
			this.search.fenbo.start_time = ('' + this.search.fenbo.dateRange[0].getTime()).substr(0, 10);
			this.search.fenbo.end_time = ('' + this.search.fenbo.dateRange[1].getTime()).substr(0, 10);
			this.fileName = '分拨单导出' +
				this.$public.FTime(this.search.fenbo.start_time, 'YYYY/MM/DD') +
				'至' +
				this.$public.FTime(this.search.fenbo.end_time, 'YYYY/MM/DD') +
				'.xlsx';
			console.log(this.fileName)
		},
		changesaleTime() {
			this.search.goods.start_time = ('' + this.search.goods.dateRange[0].getTime()).substr(0, 10);
			this.search.goods.end_time = ('' + this.search.goods.dateRange[1].getTime()).substr(0, 10);
			this.fileName = '商品销售数据单导出' +
				this.$public.FTime(this.search.goods.start_time, 'YYYY/MM/DD') +
				'至' +
				this.$public.FTime(this.search.goods.end_time, 'YYYY/MM/DD') +
				'.xlsx';
			console.log(this.fileName)
		},
		changemedicalTime() {
			this.search.medical.start_time = ('' + this.search.medical.dateRange[0].getTime()).substr(0, 10);
			this.search.medical.end_time = ('' + this.search.medical.dateRange[1].getTime()).substr(0, 10);
			this.fileName = '药品销售数据单导出' +
				this.$public.FTime(this.search.medical.start_time, 'YYYY/MM/DD') +
				'至' +
				this.$public.FTime(this.search.medical.end_time, 'YYYY/MM/DD') +
				'.xlsx';
			console.log(this.fileName)
		},
		down(p) {
			if (p == "order") {
				if (this.search.order.dateRange === '') {
					this.$message({
						message: '请选择时间范围',
						type: 'error'
					});
					return;
				} else {
					let loading = this.$loading();
					axios.get(process.env.VUE_APP_Url_order + '/api/DataExport/orderexcel', {
						params: {
							start_time: this.search.order.start_time,
							end_time: this.search.order.end_time,
						},
						responseType: 'blob'
					}).then(response => {
						console.log("导出", response);
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '财务导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
						loading.close();
					}).catch(err => {
						console.log(err)
					})
				}
			} else if (p == "ylfw") {
				if (this.search.ylfw.dateRange === '') {
					this.$message({
						message: '请选择时间范围',
						type: 'error'
					});
					return;
				} else {
					let loading = this.$loading();
					axios.get('/api/ExportData/medicalorder', {
						params: {
							start_time: this.search.ylfw.start_time,
							end_time: this.search.ylfw.end_time,
						},
						responseType: 'blob'
					}).then(response => {
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '医疗服务导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
						loading.close();
					}).catch(err => {
						console.log(err)
					})
				}
			} else if (p == "ruku") {
				if (this.search.ruku.dateRange === '') {
					this.$message({
						message: '请选择时间范围',
						type: 'error'
					});
					return;
				} else {
					let params = {
						inDateStart: this.search.ruku.start_time,
						inDateEnd: this.search.ruku.end_time,
						inOrderType: this.search.ruku.type,
						currentShopId: this.search.ruku.shopId,
					}
					// let loading = this.$loading();
					// this.$http.post(process.env.VUE_APP_Url1+'api/In/goodsSumInfoExcel', params).then(response => {
					// 	loading.close();
					// 	if(response.code===0){
					// 		window.open(response.data)
					// 	}
					// }).catch(err => {
					// 	console.log(err)
					// })
					let loading = this.$loading();
					axios.get(process.env.VUE_APP_Url66 + 'api/In/goodsSumInfoExcel', {
						params: params,
						responseType: 'blob'
					}).then(response => {
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '入库导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
						loading.close();
					}).catch(err => {
						console.log(err)
					})
				}
			} else if (p == "chuku") {
				if (this.search.chuku.dateRange === '') {
					this.$message({
						message: '请选择时间范围',
						type: 'error'
					});
					return;
				} else {
					let params = {
						outDateStart: this.search.chuku.start_time,
						outDateEnd: this.search.chuku.end_time,
						outOrderType: this.search.chuku.type,
						currentShopId: this.search.chuku.shopId,
					}
					// let loading = this.$loading();
					// this.$http.post(process.env.VUE_APP_Url1+'api/Out/goodsSumInfoExcel', params).then(response => {
					// 	loading.close();
					// 	if(response.code===0){
					// 		window.open(response.data)
					// 	}
					// }).catch(err => {
					// 	console.log(err)
					// })
					let loading = this.$loading();
					axios.get(process.env.VUE_APP_Url66 + 'api/Out/goodsSumInfoExcel', {
						params: params,
						responseType: 'blob'
					}).then(response => {
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '出库导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
						loading.close();
					}).catch(err => {
						console.log(err)
					})
				}
			} else if (p == "chengbenjia") {
				if (this.search.chengbenjia.dateRange === '') {
					this.$message({
						message: '请选择时间范围',
						type: 'error'
					});
					return;
				} else {
					console.log(this.search.chengbenjia)
					let params = {
						startTime: this.search.chengbenjia.start_time,
						endTime: this.search.chengbenjia.end_time,
						supplierId: this.search.chengbenjia.supplier,
						keyword: this.search.chengbenjia.keyword,
					}
					// let loading = this.$loading();
					// this.$http.post(process.env.VUE_APP_Url1+'api/Goods/codeprice/export', params).then(response => {
					// 	loading.close();
					// 	if(response.code===0){
					// 		window.open(response.data)
					// 	}
					// }).catch(err => {
					// 	console.log(err)
					// })
					let loading = this.$loading();
					axios.get(process.env.VUE_APP_Url1 + 'api/Goods/codeprice/export', {
						params: params,
						responseType: 'blob'
					}).then(response => {
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '成本价导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
						loading.close();
					}).catch(err => {
						console.log(err)
					})
				}
			} else if (p == "fenbo") {
				if (this.search.fenbo.dateRange === '') {
					this.$message({
						message: '请选择时间范围',
						type: 'error'
					});
					return;
				} else {
					let params = {
						keyword: this.search.fenbo.keyword,
						startTime: this.$public.FTime(this.search.fenbo.start_time),
						endTime: this.$public.FTime(this.search.fenbo.end_time),
						supplierId: this.search.fenbo.supplier,
						shop_id: this.search.fenbo.shopId,
					}
					let loading = this.$loading();
					axios.get(process.env.VUE_APP_zichan + '/api/Procurement/UpLoadMonthDistributionExcel', {
						params: params,
						responseType: 'blob'
					}).then(response => {
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '分拨单导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
						loading.close();
					}).catch(err => {
						console.log(err)
					})
				}
			} else if (p == "goods") {
				if (this.search.goods.dateRange === '') {
					this.$message({
						message: '请选择时间范围',
						type: 'error'
					});
					return;
				} else {
					let loading = this.$loading();
					axios.get(process.env.VUE_APP_Url66 + 'api/product/goods/sale/data/export', {
						params: {
							outDateStart: this.search.goods.start_time,
							outDateEnd: this.search.goods.end_time,
						},
						responseType: 'blob'
					}).then(response => {
						console.log("导出", response);
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '商品销售数据导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
						loading.close();
					}).catch(err => {
						console.log(err)
					})
				}
			} else if (p == "medical") {
				if (this.search.medical.dateRange === '') {
					this.$message({
						message: '请选择时间范围',
						type: 'error'
					});
					return;
				} else {
					let loading = this.$loading();
					axios.get(process.env.VUE_APP_Url66 + 'api/product/medical/sale/data/export', {
						params: {
							outDateStart: this.search.medical.start_time,
							outDateEnd: this.search.medical.end_time,
						},
						responseType: 'blob'
					}).then(response => {
						console.log("导出", response);
						var href = window.URL.createObjectURL(response.data); //创建下载的链接
						var downloadElement = document.createElement('a');
						downloadElement.href = href;
						downloadElement.download = '药品销售数据导出.xlsx';
						document.body.appendChild(downloadElement);
						downloadElement.click(); //点击下载
						document.body.removeChild(downloadElement); //下载完成移除元素
						window.URL.revokeObjectURL(href); //释放掉blob对象
						loading.close();
					}).catch(err => {
						console.log(err)
					})
				}
			} else if (p == "kucun") {

				let loading = this.$loading();
				axios.get(process.env.VUE_APP_Url66 + 'api/export/product/summary/data', {
					params: {
						goodsType: this.search.kucun.type,
						shopId: this.search.kucun.shopId,
					},
					responseType: 'blob'
				}).then(response => {
					console.log("导出", response);
					var href = window.URL.createObjectURL(response.data); //创建下载的链接
					var downloadElement = document.createElement('a');
					downloadElement.href = href;
					downloadElement.download = '库存汇总数据导出.xlsx';
					document.body.appendChild(downloadElement);
					downloadElement.click(); //点击下载
					document.body.removeChild(downloadElement); //下载完成移除元素
					window.URL.revokeObjectURL(href); //释放掉blob对象
					loading.close();
				}).catch(err => {
					console.log(err)
				})

			}
		}
	}
}
</script>
<style scoped lang="scss">
.page {
	height: 600px;
	background-color: #fff;
	padding: 100px 40px;

	.label {
		line-height: 40px;
		display: block;
	}
}
</style>
